// extracted by mini-css-extract-plugin
export var hidden = "_45-1";
export var leftPanel = "_45-2";
export var readonlyInspector = "_45-3";
export var rightPanel = "_45-0";